import { memo } from "react";
import { useSectionMenuContext } from "./useSectionMenuContext";

export const SectionMenuItem = memo(({ id, children }) => {
  const activeTabIndex = useSectionMenuContext();

  if (activeTabIndex !== id) return null;

  return children;
});
